import { render, staticRenderFns } from "./KernelPackageReturns.vue?vue&type=template&id=7a13a735&"
import script from "./KernelPackageReturns.vue?vue&type=script&lang=js&"
export * from "./KernelPackageReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports